<style>
    ol.khr-listing {
        counter-reset: item;
        margin-top: 1.5rem;
    }

    .khr-listing>li {
        display: block;
        margin-bottom: 1rem;
    }

    .numeric-text {
        position: relative;
        font-family: "Poppins";
    }

    .numeric-text::before {
        font-size: 16px;
        font-weight: bold;
        position: absolute;
        left: -2.5rem;
        font-family: "Poppins";
        text-align: right;
        width: 35px;
        top: -5px;
    }

    .khr-listing>li:before {
        content: counters(item, ".") ". ";
        counter-increment: item;
        font-weight: bold;
    }
</style>
<div class="khr-intro-section-wrap bg-dark text-center pt-5">
    <h1 class="text-white mb-0">Terms & Conditions</h1>
    <p class="text-white opacity-75 fw-normal mb-5">
        Last updated as on 26.03.2025
    </p>
</div>
<div class="row g-0 justify-content-center khr-overlay-card">
    <div class="col col-lg-7">
        <pmd-card class="p-4">
            <div class="text-start">
                <p class="">
                    This document is an electronic record in terms of the Information Technology Act, 2000 and rules
                    there under as applicable and the amended provisions pertaining to electronic records in various
                    statutes as amended by the Information Technology Act, 2000. This electronic record is generated by
                    a computer system and does not require any physical or digital signatures.
                </p>
                <p class="">
                    Prayosha Food Services Private Limited, a private limited company
                    incorporated under the laws of India (<strong>“Company”</strong>,
                    <strong>“we”</strong>, <strong> “us”</strong> or
                    <strong>“our"</strong>), manages and operates the website
                    <a href="https://www.petpooja.com/purchase"
                        class="text-primary fw-bold text-decoration-underline">(https://www.petpooja.com/purchase)</a>
                    and domain name, and any other linked pages, features, content, mobile
                    application ‘Purchase Scan’, or any other services we offer from time to
                    time in connection therewith (collectively the
                    <strong>"Platform”</strong>) which is an online platform which enables
                    users to optimize their purchases and purchase related decisions.
                    Further, the Platform will also analyze and store such data derived
                    from the invoices uploaded by the user in order to deduce an accurate
                    interpretation of the same. Additionally, the Platform aims to assists
                    the user to avail financial facilities (including loans from banks and
                    non-banking financial companies (collectively referred to as
                    <strong> “Financial Service Providers”</strong>)), as maybe required
                    by the user, to enable to them to manage their payment cycles
                    (collectively, the foregoing shall be referred to as the
                    <strong>“Services”</strong>).
                </p>
                <p>
                    All users of the website are advised to read and understand our
                    Privacy Policy and Terms &amp; Conditions carefully before
                    registering, accessing or using the website or any services offered by
                    the Company. By giving your consent for accessing the Platform (either
                    as a visitor or a customer), you (hereinafter referred to as
                    <strong>“you”</strong>, <strong>“your</strong>,
                    <strong>“user”</strong>, as applicable) expressly consent to our
                    collection, storage, use and disclosure of all the information shared
                    by you with the Company to any third party (wherever applicable) in
                    accordance with the terms of this Terms and Conditions and the <a href="javascript: void(0);"
                        target="_blank"
                        routerLink="/privacy"
                        class="text-primary fw-bold">Privacy
                        Policy</a>, as amended from time to time.
                </p>
                <p>
                    This document and such other rules and policies of the Platform as may
                    be amended from time to time are collectively referred to below as the
                    <strong>“Terms &amp; Conditions”</strong> or <strong>“Terms”</strong>.
                </p>
                <p>
                    We reserve the right, at our sole discretion, to change, modify, add or remove portions of these
                    Terms, at any time without any prior written notice to you. By accessing, browsing, or otherwise
                    using the Platform, including following the posting of changes, the user agrees to accept and be
                    bound by the terms (as may be amended from time to time). It is your responsibility to review these
                    terms periodically for any updates / changes. Please do not access the Platform if you do not accept
                    to any Terms or are unable to be bound by any Terms contained herein.
                </p>
                <p>
                    PLEASE READ THE TERMS CAREFULLY BEFORE PROCEEDING. IF YOU DO NOT AGREE
                    TO ALL OF THESE TERMS, DO NOT ACCESS OR USE THE PLATFORM OR THE
                    SERVICES PROVIDED BY THE PLATFORM OR THE COMPANY.
                </p>

                <p>
                    Additional terms and conditions may apply to you in respect of availing specific services and/or to
                    specific portions or features of the Platform, including but not limited to, the Services, any other
                    additional services as may be offered by us from time to time, contests, offers, schemes, promotions
                    or other similar features, all of which terms are to be read as part of these Terms. You agree to
                    abide by such other terms and conditions, including, where applicable, representing that you have
                    the legal capacity to use or participate in such service or feature. If there is a conflict between
                    these Terms and the terms posted for or applicable to a specific portion of the Platform or for any
                    specific service offered on or through the Platform, the latter terms shall control with respect to
                    your use of that portion of the Platform or the specific service. The Company expressly reserves the
                    right at any time, to add to and/or alter, modify, change or vary all or any of the terms and
                    conditions or to replace wholly or in part, the contests, offers, schemes, promotions etc. with
                    another contest, offer, scheme, promotion etc. or to withdraw it altogether.
                </p>
                <ol class="khr-listing"
                    id="numeric">
                    <li class="numeric-text">
                        <h6 class="fw-bold text-black">Application:</h6>
                        <ol class="khr-listing">
                            <li>
                                The Platform is a web-based platform with an android application that offers the
                                Services subject to these Terms as well as the Privacy Policy and any other rules and
                                policies of the Platform that the Company may publish from time to time.
                            </li>
                            <li>
                                You must read the Company’s Privacy Policy which governs the collection, use, and
                                disclosure of personal information about Users. You accept the terms of the Privacy
                                Policy and agree to the use of the personal information about you in accordance with the
                                Privacy Policy.
                            </li>
                            <li>
                                We may, from time to time, release new features on the Platform, or introduce other
                                Services and/or resources. Any such amendments will be subject to these Terms as well as
                                any additional terms of use that we may release for those specific Services or features.
                            </li>
                        </ol>
                    </li>
                    <li class="numeric-text">
                        <h6 class="fw-bold text-black">Subscription</h6>
                        <ol class="khr-listing">
                            <li>
                                It is mandatory to register or subscribe to visit, access and use the Platform. You need
                                to register, subscribe and create one or more user accounts (each an
                                <strong>“Account”</strong>) to avail
                                such Services on the Platform by providing, your name, email id, password, pan card
                                details, mobile number, bank account number, GST number and other details with respect
                                to each Account. By registering and creating your Account on the Platform the user will
                                be able to access the dashboard and be shown a sync code which can be used by user to
                                log-in to the app. Additionally, you agree to:
                                <ol type="a"
                                    class="mt-3">
                                    <li class="mb-2">
                                        provide accurate, current and complete information as may be prompted
                                        ("<strong>Registration Data</strong>") and maintain and undertake to update the
                                        same in respect of any changes;
                                    </li>
                                    <li class="mb-2">maintain the security of your password;</li>
                                    <li class="mb-2">
                                        accept all risks of unauthorized access to the Registration
                                        Data and any other information you provide to us;
                                    </li>
                                    <li class="mb-2">
                                        notify us immediately of any breach of security or any
                                        unauthorized use of your Account; and
                                    </li>
                                    <li class="mb-2">
                                        be responsible for all activity on your Account and to use
                                        and operate the same in accordance with applicable law.
                                    </li>
                                </ol>
                            </li>
                            <li>
                                We reserve the right to disallow, cancel, remove or reassign certain usernames and
                                permalinks in appropriate circumstances, as determined by us in our sole discretion, and
                                may, with or without prior notice, suspend or terminate your Account if activities occur
                                on that Account which, in our sole discretion, would or might constitute a violation of
                                these Terms, or an infringement or violation of the rights of any third party, or of any
                                applicable laws or regulations. We may at our sole discretion restore access to your
                                Account, at any time, pursuant to any suspension.
                            </li>
                            <li>
                                The Company reserves the right to cancel any reservation or
                                subscription/registration made by the user and shall provide a
                                prior written notification.
                            </li>
                            <li>
                                In case you avail services while accessing the Platform, that may be supported and/or
                                provided by third party service provider(s), for all such services your contracting
                                entity will be such third party service provider(s), as the case may be. The Company
                                disclaims all liability for any claims that may arise pursuant to your use of services
                                provided by such third party service provider(s).
                            </li>
                            <li>
                                User agrees and confirms that any Services provided to you by the Company are on best
                                efforts basis and the Company may engage services of third-party service provider(s) to
                                facilitate such Services to you. We shall not in any manner be liable to you for failure
                                or delay in providing the Services or for any temporary disablement, permanent
                                discontinuance of the Services by us or for any consequences resulting from such actions
                                or reasons that are beyond our reasonable control.
                            </li>
                            <li>
                                User acknowledges that the Services are being provided to you on a ‘as is’ and ‘as
                                available’ basis and may be interrupted while browsing, transacting, using or uploading
                                information on the Platform. User agrees that we reserve the right to suspend the
                                Services, forthwith without assigning any reason whatsoever, at our sole discretion.
                            </li>
                        </ol>
                    </li>
                    <li class="numeric-text">
                        <h6 class="fw-bold text-black">Eligibility</h6>
                        <ol class="khr-listing">
                            <li>
                                The Platform is available for use and access to users who can form legally binding
                                contracts under Indian Contract Act, 1872. For the purposes of these Terms, the term
                                ‘persons’ shall mean any sole proprietor, firm, company, corporation, government, state
                                or agency of a state or any association, trust, joint venture, consortium or partnership
                                (whether or not having separate legal personality) or any other body corporate duly
                                incorporated under the laws of India.
                            </li>
                            <li>
                                User must not use the Platform and its Services for their personal use and the Platform
                                shall be used by the User only for their business purposes.
                            </li>
                        </ol>
                    </li>
                    <li class="numeric-text">
                        <h6 class="fw-bold text-black">User Accounts and Verification of Account</h6>
                        <ol class="khr-listing">
                            <li>
                                User must be registered on the Platform to access or avail the Services for its
                                commercial purposes. You agree and acknowledge that you will transact on the Platform
                                only for your business purposes and not for personal use. Further, the Company retains
                                the right to reject an application made by the user for creation of any Account, without
                                assigning any reasons thereof.
                            </li>
                            <li>
                                When you access the Platform you are electronically communicating with the Company. The
                                Company may communicate with you by e-mail, SMS, WhatsApp messages or messages through
                                other modes of communication, phone call or by posting notices on the Platform or by
                                sending in-app notifications or any other mode of communication. For contractual
                                purposes, you consent to receive communications (including transactional, promotional
                                and/or commercial messages) in the above manner, from the Company with respect to your
                                use of the Platform and it shall be deemed by your continued use of the Platform that
                                you agree and consent to receive any communications from the Company.
                            </li>
                            <li> While registering the User account on the Platform you will be required to furnish
                                details about you and with respect to your business including without limitation,
                                business name, GSTIN, PAN, supplier’s GSTIN, TDS amount, address, mobile number and/ or
                                any other information that may be required by the Company to provide the Services in
                                relation to your business. You agree and acknowledge that we may directly or through a
                                third-party service provider validate the information provided by you on the Platform.
                                You agree to furnish additional information and provide documentary proof as may be
                                requested by us, from time to time, for the purposes of verification of your user
                                account information. If any information provided by you is found to be incorrect or
                                misleading, the Company reserves its right to take appropriate steps as it deems fit and
                                necessary. For the purposes of verification of your account information, you agree that
                                we may share your any information (including without limitation your personal
                                information) with such third party service provider in accordance with the terms of the
                                Privacy Policy. We reserve the right to seek additional information from you about you
                                and your business, from time to time and you consent to provide such additional
                                information to continue using the Platform.
                            </li>
                        </ol>
                    </li>
                    <li class="numeric-text">
                        <h6 class="fw-bold text-black">User Information</h6>
                        <p class="mt-2">
                            User will be required to provide information or material about User’s entity, its business,
                            services or products, bank account details, customer related information, other ‘know your
                            customer’ (KYC) details and/or purchase invoice as part of the registration process on the
                            Platform and/or your use of any Service or the user Account. You represent, warrant and
                            agree that:
                        </p>
                        <ol class="khr-listing">
                            <li>
                                Such information and material whether submitted during the registration process or
                                thereafter throughout the continuation of the use of the Platform or any Services is
                                true, accurate, current and complete;
                            </li>
                            <li>
                                You will maintain and promptly amend all information and material to keep it true,
                                accurate, current and complete;
                            </li>
                            <li>
                                You may be required to promptly furnish additional documents or information as and when
                                requested by the Company to continue using and accessing the Platform and availing the
                                Services; and
                            </li>
                            <li>
                                You agree to promptly provide such additional documents and information, failing which
                                the Company reserves its right to take appropriate measures as set out under these
                                Terms.
                            </li>
                        </ol>
                    </li>
                    <li class="numeric-text">
                        <h6 class="fw-bold text-black">User Obligations and Undertaking </h6>
                        <ol class="khr-listing">
                            <li>
                                You agree that (a) you will not copy, reproduce, download,
                                re-publish, sell, distribute or resell any Services or any
                                information, text, images, graphics, video clips, sound,
                                directories, files, databases or listings, etc. available on or
                                through the Platform (the <strong>“Platform Content”</strong> ),
                                and (b) you will not copy, reproduce, download, compile or
                                otherwise use any Platform Content for the purposes of operating
                                a business that competes with the Company, or otherwise
                                commercially exploiting the Platform Content or systematic
                                retrieval of Platform Content from the Platform to create or
                                compile, directly or indirectly, a collection, compilation,
                                database or directory (whether through robots, spiders,
                                automatic devices or manual processes).
                            </li>
                            <li>
                                The Company may allow users access to content, products or services offered by third
                                parties through hyperlinks (in the form of word link, banners, channels or otherwise),
                                application programming interface (API) or otherwise to such third parties' web sites
                                for services including but not limiting to accounting and purchase related. You are
                                hereby giving you consent to the Company to share any data related to You available with
                                the Company with any third party service providers. You are cautioned to read such third
                                parties’ terms and conditions and/or privacy policies before using the Platform with
                                respect to such content, products or services that you may avail. You acknowledge that
                                the Company has no control over such third parties' web sites and shall not be
                                responsible or liable to anyone for such web sites, or any content, products or services
                                made available on such web sites.
                            </li>
                            <li>
                                By posting or displaying any information, content or material (<strong>“User
                                    Content”</strong>) on the
                                Platform or providing any User Content to the Company or our representative(s), you
                                grant perpetual, worldwide, royalty-free, and sub-licensable license to the Company to
                                display, transmit, distribute, reproduce, publish, translate, and otherwise use any or
                                all of the User Content in any form, media, or technology now known or not currently
                                known in any manner and for any purpose which, in the sole discretion of the Company,
                                may be beneficial to the operation of the Platform, the provision of any Services and/or
                                the business of the User. You confirm and warrant to the Company that you have all the
                                rights, power and authority necessary to grant the above license.
                            </li>
                        </ol>
                    </li>

                    <li class="numeric-text">
                        <h6 class="fw-bold text-black">User’s responsibilities, representations and warranties:</h6>
                        <p class="mt-2">You represent, warrant and agree that:</p>
                        <ol class="khr-listing">
                            <li>
                                You are fully able and competent to understand and agree to
                                these Terms;
                            </li>
                            <li>You have full power and authority to accept these Terms;</li>
                            <li>
                                You have the authority and all necessary licenses, consents
                                and/or governmental approvals required to access the Platform
                                and make payment, borrow or repay the loan hereon;
                            </li>
                            <li>
                                You will use the Platform and any Services provided on it only
                                for lawfully permitted purposes;
                            </li>
                            <li>
                                The address you provide when registering your account on the
                                Platform is the User place of business of your business entity;
                            </li>
                            <li>
                                Your business is validly existing and incorporated / established
                                as per the provisions of applicable laws;
                            </li>
                            <li>
                                You shall comply with all applicable laws while using and
                                accessing the Platform;
                            </li>
                            <li>
                                You shall be solely responsible for obtaining all necessary
                                third-party licenses and permissions (if any required) for using
                                the Platform and/or the loan procured through the Platform;
                            </li>
                            <li>
                                Any User Content that you submit, or upload should not infringe
                                or violate any copyright, patent, trademark, trade name, trade
                                secrets or any other personal or proprietary rights of any third
                                party and/or any applicable law; and
                            </li>
                            <li>
                                You consent to the inclusion of the information provided by you
                                in the Company’s database and the usage of the same as per the
                                Privacy Policy.
                            </li>
                        </ol>
                    </li>
                    <li class="numeric-text">
                        <h6 class="fw-bold text-black">Breaches and Suspension</h6>
                        <ol class="khr-listing">
                            <li>
                                If any User breaches any Terms, or if the Company has reasonable
                                grounds to believe that a User is in breach of any Terms, or
                                could subject the Company or its affiliates to liability, or is
                                otherwise found inappropriate or unlawful in the Company’s
                                opinion, the Company shall have the right to take such
                                disciplinary actions as it deems appropriate, including without
                                limitation:
                                <ol type="a"
                                    class="mt-3">
                                    <li class="mb-2">
                                        suspending or terminating the user’s account and any and all
                                        accounts determined to be related to such account by the
                                        Company in its discretion;
                                    </li>
                                    <li class="mb-2">
                                        blocking, restricting, downgrading, suspending or
                                        terminating the subscription of, access to, or current or
                                        future use of any Service;
                                    </li>
                                    <li class="mb-2">
                                        removing any transaction history or other User Content that
                                        the user has submitted, posted or displayed; and/or
                                    </li>
                                    <li class="mb-2">
                                        any other corrective actions, discipline or penalties as the
                                        Company may deem necessary or appropriate in its sole
                                        discretion.
                                    </li>
                                </ol>
                            </li>
                            <li>
                                The Company does not pre-screen any content or information
                                posted, uploaded or transmitted on the Platform by the users and
                                the Company is under no obligation to pre- screen any such
                                content or information. However, the Company may at its
                                discretion and/or in accordance with applicable law may
                                voluntarily take down any content or information posted or
                                uploaded by you on the Platform and if the Company determines
                                that any content or information is in violation of these Terms,
                                the Company may remove such content or information from the
                                Platform without notice. Such actions do not in any manner
                                negate or dilute the Company’s position as an intermediary or
                                impose any liability on the Company with respect to content or
                                information posted, published or transmitted by users on the
                                Platform.
                            </li>
                            <li>
                                Notwithstanding anything contained herein these Terms, the
                                Company may with or without notice and in its sole discretion be
                                entitled to suspend, reduce visibility of the Service listings,
                                de-activate, or de-list any Service listings or user’s account
                                for any reasons, including without limitation, economic
                                constraints, operational difficulties, financial implications,
                                usage behavior of the user on the Platform, performance of the
                                User on the Platform, etc.
                            </li>
                            <li>
                                In the event a free/upaid user becomes inactive or if no
                                transaction is noticed by the Company for 18 continuous months
                                an extended period of time, in such a case the Company reserves
                                its right to delist, deactivate or suspend a user’s account in
                                its sole discretion, with or without giving any notice to the
                                user.
                            </li>
                            <li>
                                The Company reserves the right to cooperate fully with
                                governmental authorities, private investigators, injured third
                                parties in the investigation of any suspected criminal or civil
                                wrongdoing and/or any third parties alleging a claim against
                                you. Further, the Company may disclose the user&#39;s identity
                                and contact information, if requested by any government or law
                                enforcement body, or an injured third party as a result of a
                                subpoena or other legal action.
                            </li>
                            <li>
                                If it comes to the knowledge of the Company or the Company
                                reasonably believes that any user has availed any Services for
                                its personal use or consumption or for any purpose other than a
                                commercial purpose, the Company shall have the right in its sole
                                discretion, without intimation to the user, to take action such
                                as but not limited to suspending or terminating the user’s
                                account and any and all accounts determined to be relation to
                                such account.
                            </li>
                        </ol>
                    </li>
                    <li class="numeric-text">
                        <h6 class="fw-bold text-black">Use of Third Parties:</h6>
                        <ol class="khr-listing">
                            <li>
                                We reserve the right to engage a third-party service provider(s)
                                (including the Financial Service Providers and any third party
                                software) to assist in providing any portion of the Services to
                                you. It is hereby clarified that in so far as the collection of
                                any payments are concerned, such third party shall act in a
                                fiduciary capacity solely for the purposes of collection of
                                payment from you.
                            </li>
                            <li>
                                You acknowledge that we shall not be liable for any loss arising
                                due to any act or forbearance of any third party including any
                                governmental authority. You further acknowledge that the
                                Services are being provided in reliance of the information
                                provided by you to us and we shall not be responsible/liable for
                                any loss arising from any inaccuracy in such information.
                            </li>
                            <li>
                                Loan related services provided shall be provided to you on an
                                ‘as-is’ basis and unless agreed otherwise, we are under no
                                obligation to inspect the correctness, or completeness of any
                                services provided by any third party service provider.
                            </li>
                        </ol>
                    </li>
                    <li class="numeric-text">
                        <h6 class="fw-bold text-black">Payment of fees:</h6>
                        <ol class="khr-listing">
                            <li>
                                To the extent allowed by applicable law and subject to the
                                Privacy Policy, you acknowledge and agree that the Company may
                                use specific third-party service providers and you may incur
                                fees for services provided by them.
                            </li>
                            <li>
                                The Company shall have sole discretion to charge fees on
                                Services provided by it through the Platform in accordance with
                                its internal policies. Prior to completing each transaction, you
                                will be notified of any fees that may apply.
                            </li>
                            <li>
                                The Company will not be responsible for any fraudulent use of
                                the Services, and any payment made in such regard shall be
                                forfeited by you to the extent permissible by law.
                            </li>
                        </ol>
                    </li>
                    <li class="numeric-text">
                        <h6 class="fw-bold text-black">Transactions between User and Service Provider</h6>
                        <ol class="khr-listing">
                            <li>
                                With respect to the payment and loan related Services offered on
                                the Platform, the Company is merely a facilitator and is not and
                                cannot be a party to or control in any manner any advertisement,
                                exhibition, making available such services on the Platform.
                            </li>
                            <li>
                                When the Company enables the user to make payment, request for
                                loan and/or for repayment of loan, such Services provided will
                                be governed by the contractual arrangement entered into directly
                                between the user and the Financial Service Provider. User agrees
                                that the Company cannot and does not confirm any third-party
                                Financial Service Provider’s purported identity. The Company
                                encourages the user to exercise discretion and caution while
                                dealing with such third-party Financial Service Provider.
                            </li>
                            <li>
                                The Company does not control and is not liable to or responsible
                                for the safety, lawfulness or availability of services offered
                                by the Financial Service Providers on the Platform, or the
                                ability of the third party Financial Service Providers or the
                                ability to complete a payment to the supplier or repayment of
                                loan from the Financial Service Providers.
                            </li>
                            <li>
                                Each user acknowledges that it is fully assuming the risks of
                                conducting any transactions (hereinafter referred to as
                                <strong> “Transaction Risk” </strong>) in connection with using
                                the Platform or Services, and that it is fully assuming the
                                risks of liability or harm of any kind in connection with
                                subsequent activity of any kind relating to products or services
                                that are the subject of transactions using the Platform. Each
                                user acknowledges and undertakes that it is transacting on the
                                Platform at its own risk and is using its best and prudent
                                judgment before entering into any transactions through the
                                Platform.
                            </li>
                            <li>
                                The Company shall neither be liable nor responsible for any
                                actions or inactions of the user nor any breach of conditions,
                                representations or warranties of the products and hereby
                                expressly disclaims any and all responsibility and liability in
                                that regard. The Company shall not mediate or resolve any
                                dispute or disagreement between the user and the Financial
                                Service Providers, third party service provider and/or the
                                supplier who issued the purchase invoice.
                            </li>
                            <li>
                                In the event that any User has a dispute with any party to a
                                transaction such user agrees to release and indemnify the
                                Company (and our agents, affiliates, directors, officers and
                                employees) from all claims, demands, actions, proceedings,
                                costs, expenses and damages (including without limitation any
                                actual, special, incidental or consequential damages) arising
                                out of or in connection with such transaction. This clause shall
                                also apply to any services opted for by accessing any link from
                                the Company site to avail of any independent services related to
                                any transaction conducted on the Platform from any third party.
                            </li>
                            <li>
                                We do not make any representations pertaining to the
                                information, content, products included on or made available to
                                the user by way of the Platform and the user acknowledges that
                                we are only connecting the user to the Financial Service
                                Providers, and not providing any financial or loan related
                                services directly. User hereby further agrees, acknowledges and
                                confirms that we are not responsible in any way for the services
                                provided by the Financial Service Providers, including any
                                approval or declining of payments by the Financial Service
                                Providers or in relation to any issue and/or dispute thereof.
                                The user hereby further agrees, acknowledges and confirms that
                                under the aforesaid circumstances the only recourse will be
                                against the Financial Service Providers and we will not be made
                                a party to any such issue and/or dispute.
                            </li>
                            <li>
                                The user shall be solely responsible for obtaining all necessary
                                third party licenses and permissions (if any required under
                                applicable law) regarding the right and authority (if required
                                under applicable laws) to borrow, make payments to the supplier
                                who issued the purchase invoices, repay any loans availed from
                                the Financial Service Providers, and such use does not violate
                                any applicable laws or existing contractual agreement or third
                                party rights.
                            </li>
                        </ol>
                    </li>
                    <li class="numeric-text">
                        <h6 class="fw-bold text-black">Feedback</h6>
                        <ol class="khr-listing">
                            <li>
                                As a participant in the Platform, you agree to use careful,
                                prudent, and good judgment when leaving feedback for other users
                                or potential users of the Platform. In the event the feedback
                                violates these Terms, is inappropriate or violates propriety or
                                privacy of another user, the Company, in its sole discretion,
                                may take any of the following actions: (i) delete your feedback
                                or any of your postings; (ii) limit your Account privileges;
                                (iii) suspend your Account; and (iv) report to law enforcement
                                authorities any actions that may be illegal, and any reports it
                                receives of such conduct. When legally required or at the
                                Company’s discretion, the Company will cooperate with law
                                enforcement agencies in any investigation of alleged illegal
                                activity on this Platform.
                            </li>
                            <li>
                                <strong>Reporting inappropriate use of feedback:</strong> You
                                may contact the Company regarding any inappropriate use of
                                feedback via-email at [tapan.patel@petpooja.com.
                            </li>
                        </ol>
                    </li>
                    <li class="numeric-text">
                        <h6 class="fw-bold text-black">Intellectual Property Rights</h6>
                        <ol class="khr-listing">
                            <li>
                                The Company is the sole owner or lawful licensee of all the
                                rights and interests in the Platform and the Platform Content.
                                All title, ownership and intellectual property rights in the
                                Platform and Platform Content shall remain with the Company or
                                licensors of the Platform Content, as the case may be. All
                                rights not otherwise claimed under the Terms or by the Company
                                are hereby reserved.
                            </li>
                            <li>
                                The unauthorized copying, modification, use or publication of the “<strong>Petpooja
                                    Purchase</strong>” or “Purchase Scan” mark and any other related icons and logos
                                marks is strictly prohibited.
                            </li>
                            <li>
                                The Company may, at its sole discretion, permit the user, in writing, to use
                                “<strong>Petpooja Purchase</strong>”, “Purchase Scan” and any other related icons and
                                logos for indicative purposes in the form and manner and terms and conditions as maybe
                                agreed by the Company.
                            </li>
                            <li>
                                You shall be solely responsible for any content or information
                                posted or transmitted on the Platform and shall indemnify the
                                Company against any claim or liability arising from any content
                                or information posted or transmitted by You on the Platform.
                            </li>
                        </ol>
                    </li>
                    <li class="numeric-text">
                        <h6 class="fw-bold text-black">INDEMNIFICATION</h6>
                        <ol class="khr-listing">
                            <li>
                                By accepting these Terms and using the Platform and/or availing
                                the Services, you agree that you shall defend, indemnify and
                                hold the Company, its directors, employees, shareholders,
                                officers and other representatives
                                <strong> (“Indemnified Parties”) </strong> harmless from and
                                against any and all claims, costs, damages, losses, liabilities
                                and expenses (including attorneys&#39; fees and costs) arising
                                out of or in connection with: (i) misuse of your access to and
                                use of the Platform, the Service and/or the Platform Content;
                                (ii) any loss or injury to the Indemnified Parties resulting
                                from or attributable to your acts or omissions; (iii) your
                                violation or breach of these Terms or any applicable law or
                                regulation; (iv) your violation of any rights of any third
                                party; or (vi) any and all third-party claims based upon (A) the
                                content of any communications transmitted by you; and/or (B)
                                transactions undertaken by you.
                            </li>
                            <li>
                                We shall not have any liability whatsoever for any claims arising from: (a) any of your
                                acts or omissions; (b) compliance with the instructions given by you or any person
                                acting on your behalf; (c) an act or order of any government agencies; (d) default in
                                repayment of loan or payment to supplier; (e) any force majeure event; (f) any cause
                                which we could not avoid and the consequences whereof we could not prevent by the
                                exercise of reasonable diligence; and/or (h) any dispute or claims between you and the
                                Financial Service Provider or the supplier issuing purchase invoice including without
                                limitation relating repayment of loan or payment for the services/ products
                                availed/purchased by you.
                            </li>
                            <li>
                                To the maximum extent permitted by law, the Services provided by the Company on or
                                through the Platform are provided "as is", "as available" and “with all faults”, and the
                                Company hereby expressly disclaims any and all warranties, express or implied, including
                                but not limited to, any warranties of condition, quality, durability, performance,
                                accuracy, reliability, merchantability or fitness for a particular purpose. All such
                                warranties, representations, conditions, and undertakings are hereby excluded.
                            </li>
                            <li>
                                Under no circumstances will the Company be liable for any consequential, incidental,
                                special, exemplary or punitive damages, including but not limited to any lost profits
                                that result from your use of this Platform and/or any Services availed, even if the
                                Company has been advised of the possibility of such damages.
                            </li>
                        </ol>
                    </li>

                    <li class="numeric-text">
                        <h6 class="fw-bold text-black">GENERAL</h6>
                        <ol class="khr-listing">
                            <li>
                                To the extent that anything in or associated with the Platform is in conflict or
                                inconsistent with these Terms, these Terms shall take precedence and prevail. Our
                                failure to enforce any provision of these Terms shall not be deemed a waiver of such
                                provision nor of the right to enforce such provision. Our rights under these Terms shall
                                survive any discontinuance of the access or use of the Platform and/or Services.
                            </li>
                            <li>
                                Under no circumstances shall the Company be held liable for any losses, delay or failure
                                or disruption of the content or services delivered through the Platform resulting
                                directly or indirectly from acts of nature, forces or causes beyond our reasonable
                                control, including without limitation, internet failures, computer, telecommunications
                                or any other equipment failures, electrical power failures, strikes, labor disputes,
                                riots, insurrections, civil disturbances, shortages of labor or materials, fires, flood,
                                storms, explosions, acts of God, war, governmental actions, epidemics, pandemics,
                                curfews, lock-down, orders of domestic or foreign courts or tribunals or non-performance
                                of third parties.
                            </li>
                            <li>
                                These Terms together with the subscription/registration form (as applicable) and Privacy
                                Policy shall constitute the entire agreement between you and the Company.
                            </li>
                            <li>
                                If any provision of these Terms is held to be invalid or unenforceable, such provision
                                shall be struck and the remaining provisions shall be enforced to the fullest extent
                                under
                                law.
                            </li>
                            <li>
                                Grievance Redressal:
                                <ol type="a"
                                    class="mt-3">
                                    <li class="mb-2">
                                        If there are any questions regarding these Terms, please write to the Grievance
                                        Officer.
                                    </li>
                                    <li class="mb-2">
                                        Any complaints, or concerns with regards to content and or comment or breach of
                                        these Terms, Privacy Policy shall be immediately informed to the designated
                                        Grievance Officer as mentioned below via in writing or through email. The
                                        Grievance Officer shall acknowledge the complaint within 72 (seventy-two) hours
                                        and redress the complaints within 15 (fifteen) days from the date of receipt of
                                        complaint.
                                    </li>
                                    <li class="mb-2">
                                        Details of the Grievance Officer:
                                        <p>Name: Tapan Patel <br>
                                            Designation: Vice President – New Initiatives <br>
                                            Email: tapan.patel@petpooja.com</p>
                                    </li>
                                </ol>
                            </li>
                            <li> <b>Jurisdiction:</b> Any kind of dispute arising out of the Services and Platform and
                                its users
                                will be dealt in Ahmedabad and shall be governed in accordance with Indian Law.
                                Further, the courts of Ahmedabad shall have exclusive jurisdiction to adjudicate the
                                same.</li>
                        </ol>
                    </li>
                </ol>
            </div>
        </pmd-card>
    </div>
</div>